import React, { useState, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";

const QuickParkDialog = ({ 
  isOpen, 
  onClose, 
  onSubmit,
  loading 
}) => {
  const [parkName, setParkName] = useState("");

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!parkName.trim()) return;
    
    const success = await onSubmit(parkName.trim());
    if (success) {
      setParkName("");
    }
  }, [parkName, onSubmit]);

  const handleClose = useCallback(() => {
    setParkName("");
    onClose();
  }, [onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader className="flex flex-row items-start justify-between">
          <div>
            <DialogTitle>Yeni Park Ekle</DialogTitle>
            <DialogDescription>
              Hızlıca yeni bir park ekleyin ve otomatik olarak seçilsin
            </DialogDescription>
          </div>
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-8 w-8 rounded-full hover:bg-red-100 hover:text-red-600 -mt-2 -mr-2"
            onClick={handleClose}
          >
            <X className="h-5 w-5" />
          </Button>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="quick-park-name">Park Adı *</Label>
            <Input
              id="quick-park-name"
              value={parkName}
              onChange={(e) => setParkName(e.target.value)}
              placeholder="Örn: Kızılay Parkı"
              required
              autoFocus
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={handleClose}>
              İptal
            </Button>
            <Button type="submit" disabled={loading || !parkName.trim()}>
              {loading ? "Ekleniyor..." : "Ekle ve Seç"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QuickParkDialog);
